import { TMasterOccupation } from "@/api/entities/master-occupation.entity";
import { useSetHiddenMasterOccupation } from "@/api/services/global/master";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenOccupationModalProps = {
  hiddenOccupation?: TMasterOccupation;
  setHiddenOccupation: Dispatch<SetStateAction<TMasterOccupation | undefined>>;
};

export const HiddenOccupationModal: FC<THiddenOccupationModalProps> = ({ hiddenOccupation, setHiddenOccupation }) => {
  const setHiddenMutation = useSetHiddenMasterOccupation();

  const handleSubmit = async () => {
    if (!hiddenOccupation) {
      return;
    }
    try {
      await setHiddenMutation.mutateAsync({ id: toNumber(hiddenOccupation.id), payload: { isHidden: !hiddenOccupation.isHidden } });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenOccupation(undefined);
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenOccupation?.isHidden ? "有効化の確認" : "無効化の確認"}
      isOpen={Boolean(hiddenOccupation)}
      onClose={() => setHiddenOccupation(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={handleSubmit}
      isLoadingOkBtn={setHiddenMutation.isPending}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenOccupation?.isHidden ? "この行が有効化されますが、よろしいですか。" : "この項目が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
